import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Alert, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
const DismissableMessage = ({ message, severity = 'error', onClose, }) => {
    const [isDismissed, setIsDismissed] = useState(false);
    if (isDismissed)
        return null;
    const handleClose = () => {
        setIsDismissed(true);
        if (onClose)
            onClose();
    };
    return (_jsx(Alert, { severity: severity, action: (_jsx(IconButton, { "aria-label": "close", color: "inherit", size: "small", onClick: handleClose, children: _jsx(CloseIcon, { fontSize: "inherit" }) })), sx: { mb: 2 }, children: message }));
};
DismissableMessage.defaultProps = {
    severity: 'error',
    onClose: undefined,
};
export default DismissableMessage;
//# sourceMappingURL=DismissableMessage.js.map